<template>
  <footer
    class="h-footer px-55px md:px-97 pt-10px"
  >
    <div
      class="grid grid-cols-1fr md:grid-cols-3fr w-full md:border-b-2 border-gray-300 justify-items-center items-center pb-10px"
    >
      <p class="contact text-center text-sm text-skin-secondary">
        ECUADOR <br class="md:hidden" />
        {{number}}
      </p>

      <img :src="logo" alt="" class="
        hidden md:block
        h-8
        w-24 object-center object-contain	
      ">

      <div class="flex pt-10px md:py-0 items-center">
        <a target="_blank" :href="`mailto:${mail}`"
          ><Mail class="cursor-pointer h-24px w-24px"
        /></a>
        <a target="_blank" :href="instagram"
          ><Instagram class="mx-25 cursor-pointer h-24px w-24px"
        /></a>
        <a target="_blank" :href="facebook"
          ><Facebook class="cursor-pointer h-24px w-24px"
        /></a>
      </div>
    </div>

    <div class="grid grid-cols-1fr justify-items-center py-10px text-center">
      <p class="text-xs text-skin-dark font-medium text-skin-secondary">
        Copyright © {{name}} 2020
        <span class="hidden md:inline-block"> - </span> Todos los derechos
        reservados
      </p>
    </div>
  </footer>
</template>

<script>
import Mail from "../components/icons/Mail.vue";
import Instagram from "../components/icons/Instagram.vue";
import Facebook from "../components/icons/Facebook.vue";
export default {
  components: {
    Mail,
    Instagram,
    Facebook,
  },
  props:{
    name:{
      type: String,
      default:'',
    },
    logo:{
      type: String,
      required: true,
    },
    mail:{
      type: String,
      default:'',
    },
    instagram:{
      type: String,
      default:'',
    },
    facebook:{
      type: String,
      default:'',
    },
    number:{
      type: String,
      default:'',
    },
  }
};
</script>
